import React from 'react';
import { Box, Input, Select } from '@apia/theme';
import { notify } from '../../components/common/notifications/util';
import { IconsMap } from '@apia/icons';

const IconsGallery = () => {
  const [filteredIcons, setFilteredIcons] = React.useState(
    Object.entries(IconsMap),
  );
  const [size, setSize] = React.useState(32);
  const [color, setColor] = React.useState('#000000');
  return (
    <Box {...window.getVariant('layout.test.iconsGallery')}>
      <Box className="controls">
        <Input
          placeholder="Buscar"
          onChange={(ev) =>
            setFilteredIcons(
              Object.entries(IconsMap).filter(
                ([name, { tags }]) =>
                  name.match(new RegExp(ev.target.value, 'i')) ||
                  tags.find((current) =>
                    current.match(new RegExp(ev.target.value, 'i')),
                  ),
              ),
            )
          }
        />
        <Select
          value={size}
          onChange={(ev) => setSize(Number(ev.target.value))}
        >
          <option value={16}>16</option>
          <option value={32}>32</option>
          <option value={48}>48</option>
          <option value={64}>64</option>
          <option value={128}>128</option>
          <option value={256}>256</option>
        </Select>
        <input
          value={color}
          type="color"
          onChange={(ev) => setColor(ev.target.value)}
        />
      </Box>
      <Box className="grid">
        {filteredIcons
          .sort((a, b) => (a[0] < b[0] ? -1 : 1))
          .map(([name, { icon: Icon }]) => (
            <Box
              className="iconsBox"
              key={name}
              onClick={() => {
                void navigator.clipboard.writeText(name);
                notify({ message: 'Nombre de ícono copiado', type: 'success' });
              }}
            >
              <Box className="icons">
                <Icon size={size} color={color} />
              </Box>
              {name}
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default IconsGallery;
